// view.js — safe version (n'interfère pas avec les tabs et autres scripts)

document.addEventListener('DOMContentLoaded', () => {
  // ====== TRI DEFENSIF LOCAL AUX GROUPES UNIQUEMENT ======
  (function () {
    // Une priorité non renseignée (ou égale à 0, qui ne compte pas comme une
    // vraie priorité) doit toujours finir en fin de liste, quel que soit le
    // sens du tri : fallback = "pire valeur possible" (+Infinity).
    function parseIntSafe(v, fallback = Number.POSITIVE_INFINITY) {
      if (v === null || v === undefined || v === '') return fallback;
      const n = parseInt(String(v), 10);
      if (!Number.isFinite(n)) return fallback;
      return n <= 0 ? fallback : n;
    }

    function getName(el) {
      if (el.dataset?.name) return el.dataset.name.trim();
      const h3 = el.querySelector && el.querySelector('h3');
      return (h3?.textContent || '').trim();
    }

    function getLastName(el) {
      return (el.dataset?.lastname || '').trim();
    }

    // Sans priorité (Infinity) finit toujours en dernier, quel que soit le
    // sens choisi. Entre deux priorités réelles, "descending" inverse
    // l'ordre (plus grande valeur en premier) au lieu de 1 = la plus haute.
    function comparePriority(av, bv, descending) {
      const aHas = av !== Number.POSITIVE_INFINITY;
      const bHas = bv !== Number.POSITIVE_INFINITY;
      if (aHas !== bHas) return aHas ? -1 : 1;
      if (!aHas) return 0;
      return descending ? bv - av : av - bv;
    }

    function sortGroup(wrap) {
      try {
        if (!wrap || !wrap.querySelectorAll) return;
        // Empêche les tris répétés inutiles
        if (wrap.dataset.brSorted === '1') return;

        const sortBy = (wrap.dataset.sortBy || 'priority1').toLowerCase();
        const priorityDescending = wrap.dataset.priorityDescending === '1';

        // Ordre manuel ("Custom" côté éditeur) : le PHP a déjà rendu les
        // cartes dans l'ordre voulu (post__in) — ne pas y toucher ici.
        if (sortBy === 'custom') {
          wrap.dataset.brSorted = '1';
          return;
        }

        const cards = Array.from(wrap.querySelectorAll('.br-contact-card'));
        if (!cards.length) return;

        const getP1 = (el) => parseIntSafe(el.dataset?.priority1);
        const getP2 = (el) => parseIntSafe(el.dataset?.priority2);

        let comparator;
        if (sortBy === 'priority2') {
          comparator = (a, b) => {
            const cmp = comparePriority(getP2(a), getP2(b), priorityDescending);
            if (cmp !== 0) return cmp;
            const cmp1 = comparePriority(getP1(a), getP1(b), priorityDescending);
            if (cmp1 !== 0) return cmp1;
            return getName(a).localeCompare(getName(b), undefined, { sensitivity: 'base' });
          };
        } else if (sortBy === 'name') {
          comparator = (a, b) =>
            getName(a).localeCompare(getName(b), undefined, { sensitivity: 'base' });
        } else if (sortBy === 'lastname') {
          comparator = (a, b) => {
            const cmp = getLastName(a).localeCompare(getLastName(b), undefined, { sensitivity: 'base' });
            if (cmp !== 0) return cmp;
            return getName(a).localeCompare(getName(b), undefined, { sensitivity: 'base' });
          };
        } else {
          // default / priority1
          comparator = (a, b) => {
            const cmp = comparePriority(getP1(a), getP1(b), priorityDescending);
            if (cmp !== 0) return cmp;
            const cmp2 = comparePriority(getP2(a), getP2(b), priorityDescending);
            if (cmp2 !== 0) return cmp2;
            return getName(a).localeCompare(getName(b), undefined, { sensitivity: 'base' });
          };
        }

        // Ne réorganiser QUE l’ordre des .br-contact-card à l'intérieur du wrap
        const frag = document.createDocumentFragment();
        cards.sort(comparator).forEach(card => frag.appendChild(card));
        wrap.appendChild(frag);

        wrap.dataset.brSorted = '1';
      } catch (e) {
        // silencieux en prod
      }
    }

    function sortAllGroups() {
      document.querySelectorAll('.br-contact-group').forEach(wrap => {
        // Reset le flag si l’onglet vient de s’afficher (re-triable)
        wrap.dataset.brSorted = '';
        sortGroup(wrap);
      });
    }

    // 1) Tri au chargement
    sortAllGroups();

    // 2) Re-tri après affichage d’un onglet (supporte plusieurs libs sans les “importer”)
    const retri = () => setTimeout(sortAllGroups, 0);

    // Bootstrap (v4/v5)
    document.addEventListener('shown.bs.tab', retri);
    document.addEventListener('shown.bs.collapse', retri);

    // ARIA tabs génériques / Gutenberg Tabs / autres
    document.addEventListener('click', (e) => {
      const isTabRole = e.target?.getAttribute && e.target.getAttribute('role') === 'tab';
      const isWpTab = e.target?.classList?.contains('wp-block-tabs__tab');
      const isDataToggleTab = e.target?.matches?.('[data-toggle="tab"],[data-bs-toggle="tab"]');
      if (isTabRole || isWpTab || isDataToggleTab) retri();
    });

    // Si tu as un event custom quand un tab s’affiche, relance:
    // document.addEventListener('br-tabs:shown', retri);
  })();

  // ====== MODALE (ton code existant, inchangé) ======
  // Création de l'overlay et du modal
  const modalOverlay = document.createElement('div');
  modalOverlay.className = 'br-contact-modal-overlay';

  const modal = document.createElement('div');
  modal.className = 'br-contact-modal';

  const closeButton = document.createElement('span');
  closeButton.className = 'modal-close';
  closeButton.innerHTML = '&times;';
  closeButton.addEventListener('click', closeModal);

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  function closeModal() {
    modalOverlay.style.display = 'none';
    modal.classList.remove('loaded');
    document.body.classList.remove('br-no-scroll'); // ✅ rétablit le scroll
  }

  // Header + body du modal
  const header = document.createElement('div');
  header.className = 'br-modal-header';

  const body = document.createElement('div');
  body.className = 'br-modal-body';

  modal.appendChild(header);
  modal.appendChild(body);
  modal.appendChild(closeButton);
  modalOverlay.appendChild(modal);
  document.body.appendChild(modalOverlay);

  // Ouvrir le modal au clic sur une carte
  document.body.addEventListener('click', (e) => {
    const card = e.target.closest?.('.br-contact-card');
    if (!card) return;

    const name = card.dataset.name || card.querySelector('h3')?.textContent?.trim() || '';
    const lastName = card.dataset.lastname || '';
    const lastNameUppercase = card.dataset.lastnameUppercase !== '0';
    const title = card.dataset.jobtitle || '';
    const title2 = card.dataset.title2 || '';
    const companyRaw = card.dataset.company || '';
    const country = card.dataset.country || '';

    // Normalisation du nom d'organisation
    const normalizedCompany = companyRaw.toLowerCase().replace(/[\s\-_.]/g, '').trim();

    let logoUrl = card.dataset.logo || '';

    if (!logoUrl && (
      normalizedCompany === 'itu' ||
      normalizedCompany === 'itur' ||
      normalizedCompany === 'itut' ||
      normalizedCompany === 'internationaltelecommunicationunion'
    )) {
      logoUrl = 'https://www.itu.int/PublishingImages/masterpage/logos/ITU-logo.svg';
    }

    const img = card.querySelector('img')?.cloneNode?.(true);
    const bioEl = card.querySelector('.br-contact-bio');
    const bio = bioEl?.textContent?.trim();

    if (!bio) return;

    // Nettoyage
    header.innerHTML = '';
    body.innerHTML = '';

    // Header
    const headerRow = document.createElement('div');
    headerRow.className = 'br-modal-header-line';

    const nameSpan = document.createElement('span');
    nameSpan.className = 'br-modal-name';
    nameSpan.append(name);
    if (lastName) {
      const lastNameSpan = document.createElement('span');
      if (lastNameUppercase) lastNameSpan.className = 'br-contact-lastname';
      lastNameSpan.textContent = lastName;
      nameSpan.append(' ', lastNameSpan);
    }

    const metaText = [title, title2, companyRaw, country].filter(Boolean).join(' - ');
    const metaSpan = document.createElement('span');
    metaSpan.className = 'br-modal-meta';
    metaSpan.textContent = metaText;
    if (metaText) metaSpan.title = metaText;

    headerRow.appendChild(nameSpan);
    headerRow.appendChild(metaSpan);
    header.appendChild(headerRow);
    header.appendChild(closeButton);

    // BODY : photo + logo + bio
    const photoWrapper = document.createElement('div');
    photoWrapper.className = 'modal-photo';

    if (img) {
      photoWrapper.appendChild(img);

      if (logoUrl) {
        const logoSection = document.createElement('div');
        logoSection.className = 'modal-logo-section';
        logoSection.style.marginTop = '20px';
        logoSection.style.textAlign = 'center';

        const separator = document.createElement('div');
        separator.style.height = '1px';
        separator.style.background = '#e5f5fb';
        separator.style.margin = '10px auto';

        const logoImg = document.createElement('img');
        logoImg.src = logoUrl;
        logoImg.alt = 'Company Logo';
        logoImg.style.maxWidth = '50%';
        logoImg.style.height = 'auto';
        logoImg.style.display = 'block';
        logoImg.style.margin = '10px auto 0';
        logoImg.style.border = 'none';
        logoImg.style.boxShadow = 'none';
        logoImg.style.background = 'transparent';
        logoImg.style.borderRadius = '0';

        logoSection.appendChild(separator);
        logoSection.appendChild(logoImg);
        photoWrapper.appendChild(logoSection);
      }
    }

    const bioWrapper = document.createElement('div');
    bioWrapper.className = 'modal-bio';
    bioWrapper.innerHTML = `<p>${bio.replace(/\n/g, '</p><p>')}</p>`;

    body.appendChild(photoWrapper);
    body.appendChild(bioWrapper);

    modalOverlay.style.display = 'flex';
    modal.classList.add('loaded');
    document.body.classList.add('br-no-scroll'); // ✅ empêche le scroll du fond
  });

  // Fermer avec Échap
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });
});
